module.exports = __webpack_public_path__ + "assets/legend.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend.jpg
// module id = 1187
// module chunks = 7